var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLongLeft = function SvgArrowLongLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    fill: "none",
    viewBox: "0 0 22 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.9 9.333h14.867q.567 0 .95-.383A1.3 1.3 0 0 0 21.1 8a1.3 1.3 0 0 0-.383-.95 1.3 1.3 0 0 0-.95-.383H4.9l3.8-3.8q.4-.4.384-.934A1.4 1.4 0 0 0 8.7 1a1.36 1.36 0 0 0-.95-.417 1.24 1.24 0 0 0-.95.384l-6.1 6.1a1.2 1.2 0 0 0-.283.433 1.5 1.5 0 0 0-.083.5q0 .267.083.5.083.234.283.433l6.1 6.1q.4.4.95.384A1.36 1.36 0 0 0 8.7 15q.367-.4.384-.933a1.22 1.22 0 0 0-.384-.934z"
  })));
};
export default SvgArrowLongLeft;